export { default } from './EmprestimoGarantiaCarroApp';
